import useCapabilities from "@/hooks/useCapabilities";
import JobsTableLayout from "@/pages/_layouts/jobs/JobsTableLayout";
import { HiringStatus } from "@/pages/_layouts/jobs/types";
import MyJobsSkeleton from "@/pages/_layouts/jobs/_components/MyJobsSkeleton";

export default function MyJobsPage() {
  const { id: ownerId } = useCapabilities();

  if (!ownerId) {
    return <MyJobsSkeleton />;
  }

  return (
    <JobsTableLayout
      columnHeaders={{
        title: true,
        facility: true,
        section: true,
        serviceLevel: false,
        totalCompensation: true,
        employer: true,
        owner: false,
        postedOn: true,
        submissionDeadline: true,
        applicantCount: true,
        postingStage: true,
        jobStatus: true
      }}
      filters={{
        postingStage: true,
        jobStatus: true,
        serviceLevel: true,
        postedDateRange: true,
        section: true,
        owner: false
      }}
      defaultValues={{
        ownerId: ownerId || undefined,
        stage: [],
        status: [HiringStatus.IN_PROGRESS, HiringStatus.EXPIRED]
      }}
      defaultSort={[{ id: "goLiveTime", desc: true }]}
    />
  );
}
